import React from 'react'

import { Container, H1, NotFound } from '../index.js'

const is404 = (error) => error && ((error.status && error.status === 404) || (error.response && is404(error.response)))

const Generic = ({error}) => {
  if (is404(error)) return <NotFound />
  return (
    <Container section>
      <H1>An error occured, unable to load page.</H1>
      {error
        ? <pre>{error.message || error }</pre>
        : null
      }
    </Container>
  )
}

export default Generic



// WEBPACK FOOTER //
// ./client/src/components/errors/Generic.js